module.exports = __webpack_public_path__ + "img/13.94d1740d.jpg";